import { axiosWrapper } from '../services/axios.wrapper'
import * as utility from "../utilities/utils";
import {
    getCardConfirmationRequest, getCardConfirmationHeader, getTrackingRequestPayload, getTrackingRequestHeaders, getSwitchHeader} from '../utilities/utils';
import {Buffer} from 'buffer';

export const postCardConfirmationInfo = (formData, sessionID, productType) => {

    let confirmUrl = ''
    confirmUrl = '/eca/api/v1/'
    let endPoint = ''
    endPoint = 'confirm'
    var headers = getCardConfirmationHeader(formData.eventID, sessionID);

    var cardConfirmationRequest = getCardConfirmationRequest(formData, sessionID, formData.eventID, productType)
    return axiosWrapper.post(
        confirmUrl,
        endPoint,
        headers,
        JSON.stringify(cardConfirmationRequest))
}

export const switchInfo = (eventID, partner, sessionID) => {
    let switchUrl = ''
    switchUrl = '/eca/api/v1/switch'

    var headers = getSwitchHeader(eventID, partner, sessionID);
    return axiosWrapper.get(
        switchUrl,
        headers)
}

export const environmentVaribleInfo = (language, flowInd, partner, eventID, useraction, sessionID) => {

    let configUrl = ''
    const queryParams = new URLSearchParams({
        language,
        flowind: flowInd,
        partner,
        useraction
    });
    configUrl = '/eca/api/v1/ecaconfig?' + queryParams.toString()

    var headers = {
        'WF-senderMessageId': eventID,
        "SessionID": sessionID
    };
    return axiosWrapper.get(configUrl, headers)
}

export const trackEvent = (page, event, sessionID) => {

    let eventID = utility.getUniqueID()

    let configUrl = ''
    configUrl = '/eca/api/v1/';
    const endPoint = 'trackingevent';

    var headers = getTrackingRequestHeaders(eventID, sessionID);
    const payload = getTrackingRequestPayload(page, event, eventID, sessionID);


    return axiosWrapper.post(configUrl, endPoint, headers, JSON.stringify(payload));
}
